export default __webpack_public_path__ + "static/media/img2.308eab8b.png";